import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

import { ContentCoverImage } from "~/components/content/content-cover-image";
import { Figure } from "~/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "~/components/content/content-headline/styles";
import { EntityLink } from "~/components/entity-link";

export const StyledContentCoverImage = styled(ContentCoverImage)`
  border-radius: 32px;
`;

const offset = 8;
export const Cover = styled.div`
  position: relative;

  &::before,
  &::after {
    position: absolute;
    inset-block-start: -${offset}px;
    inset-inline-start: ${offset}px;
    content: "";

    inline-size: calc(100% - ${offset}px);
    block-size: calc(100%);

    border-radius: 32px;
  }

  &::before {
    z-index: 2;

    border: 1px solid #000000;
  }

  &::after {
    z-index: 0;

    background: #ffffff;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    flex: 1;

    min-inline-size: 320px;
    margin-block-end: 0;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    flex: auto;

    inline-size: 100%;
    max-inline-size: 320px;
    margin-block-end: 0;
  }

  ${Figure} {
    position: relative;
    z-index: 1;

    inline-size: calc(100% - ${offset}px);
    block-size: calc(100% - ${offset}px);
  }
`;

export const Headline = styled.div`
  margin-block-end: 16px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;
  }

  ${ContentHeadline}, ${SponsorHeadline} {
    color: #1b4191;
    font-size: 24px;
    font-family: ${fontAngkor};
    line-height: 28px;
    letter-spacing: -0.72px;
    text-align: start;

    ${props => props.theme.breakpoints.up("tablet")} {
      display: block;

      font-size: 32px;
      line-height: 38px;
      letter-spacing: -0.96px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    align-items: start;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "cover" min-content
    "content" min-content
    / 270px;
  gap: 24px;
  justify-content: center;
  align-items: center;

  ${Content} {
    grid-area: content;
  }

  ${Cover} {
    grid-area: cover;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "cover content" min-content
      / 320px 1fr;
    gap: 32px;
  }
`;

export const Container = styled.div``;
